<template>
  <van-popover
    v-bind="$attrs"
    v-on="$listeners"
    :placement="placement"
    trigger="click"
    :boundary="'body'"
    @closed="selectClosed"
  >
    <div class="select-panel-container">
      <ul
        class="select-panel"
        v-if="searchOpt.type === SEARCH_BOX_TYPE.MULTIPLE_COL_SELECT"
      >
        <li
          @click="handleLabelSelectItem(item)"
          v-for="(item, index) in labelOptions"
          :key="index"
          :class="[
            item.disabled && 'disabled',
            'panel-item',
            matchLabelActive(item.value, currentLabelValue) && 'active',
          ]"
        >
          {{ item.name }}
        </li>
      </ul>
      <ul class="select-panel">
        <li
          @click="handleSelectItem(item)"
          v-for="(item, index) in selectList"
          :key="index"
          :class="[
            item.disabled && 'disabled',
            'panel-item',
            matchLabelActive(item.value, currentValue) && 'active',
          ]"
        >
          {{ item.name }}
        </li>
      </ul>
    </div>
    <template #reference>
      <div class="select-main">
        <div class="select-title" v-if="searchOpt.selectLabel">
          {{ searchOpt.selectLabel }}
        </div>
        <div :class="['select-button', 'ellipsis', $attrs.value && 'active']">
          <div v-if="label" class="label">{{ label }}</div>
          <div v-else-if="customDateStrComputed && searchOpt.span === 24">
            {{ customDateStrComputed }}
          </div>
          <div v-else>{{ customLabelName || labelName }}</div>
          <img
            src="@/assets/images/agent/select-arrow.png"
            v-if="
              !(
                (searchOpt.type === SEARCH_BOX_TYPE.SELECT ||
                  searchOpt.type === SEARCH_BOX_TYPE.DATE_SELECT ||
                  searchOpt.type === SEARCH_BOX_TYPE.MULTIPLE_COL_SELECT) &&
                searchOpt.smallSize &&
                searchOpt.span !== 24
              )
            "
          />
        </div>
      </div>
    </template>
  </van-popover>
</template>

<script>
import moment from 'moment/moment'
import { OTHER_TYPE, SEARCH_BOX_TYPE } from '@/components/VzanSearchBox/enum'
import { DATE_TYPE } from '@/components/VzanSearchBox/enum'
export default {
  name: 'CustomSelect',
  props: {
    searchOpt: {
      type: Object,
      default: () => {
        return {}
      },
    },
    selectList: Array,
    labelOptions: Array,
    selectValue: [String, Number, Array],
    selectLabelValue: [String, Number, Array],
    label: String,
    customDateStr: [String, Array],
    placement: {
      type: String,
      default: () => {
        return 'bottom-start'
      },
    },
    dateType: {
      type: String,
      default: () => {
        return DATE_TYPE.DATETIME
      },
    },
    multiple: Boolean,
    customLabelName: String,
  },
  data() {
    return {
      currentValue: '',
      currentLabelValue: '',
      customDatePopupOpenFlag: false,
      hasSelected: false,
    }
  },
  watch: {
    selectValue: {
      handler(val) {
        this.currentValue = val
      },
      immediate: true,
      deep: true,
    },
    selectLabelValue: {
      handler(val) {
        this.currentLabelValue = val
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    SEARCH_BOX_TYPE() {
      return SEARCH_BOX_TYPE
    },
    labelName() {
      try {
        if (this.multiple) {
          let selectName = this.selectList
            .filter(item => this.currentValue.includes(item.value))
            .map(item => item.name)
          return selectName.length ? selectName.join(',') : '全部'
        } else {
          return this.selectList.filter(item => {
            if (
              Array.isArray(this.currentValue) &&
              Array.isArray(item.value) &&
              !this.multiple
            ) {
              return this.currentValue.join(',') == item.value.join(',')
            } else {
              return item.value === this.currentValue
            }
          })[0].name
        }
      } catch (e) {
        return '全部'
      }
    },
    formatStr() {
      const formatItem = {
        'year-month': 'YYYY-MM',
        date: 'YYYY-MM-DD',
        datetime: 'YYYY-MM-DD HH:mm',
      }
      return formatItem[this.dateType] || 'YYYY-MM-DD HH:mm'
    },
    customDateStrComputed() {
      if (Array.isArray(this.customDateStr) && this.customDateStr.length > 0) {
        if (this.dateType) {
          const startTime = this.customDateStr[0].replace(/\//g, '-')
          const endTime = this.customDateStr[1].replace(/\//g, '-')
          return `${moment(startTime).format(this.formatStr)} - ${moment(
            endTime
          ).format(this.formatStr)}`
        } else {
          return `${this.customDateStr[0]} - ${this.customDateStr[1]}`
        }
      } else {
        return this.customDateStr || ''
      }
    },
  },
  methods: {
    selectClosed() {
      // this.customDatePopupOpenFlag 兼容选择自定义时间的时候关闭弹窗触犯修改   this.currentValue === OTHER_TYPE.CUSTOM_DATE 兼容默认自定义时间的时候，关闭弹窗触发修改
      if (
        this.customDatePopupOpenFlag ||
        this.currentValue === OTHER_TYPE.CUSTOM_DATE
      ) {
        this.customDatePopupOpenFlag = false
        return
      }
      if (this.hasSelected) {
        // 当选择后 关闭弹窗才调用搜索
        this.$emit('change', this.searchOpt, this.currentValue)
        this.hasSelected = false
      }
    },
    matchLabelActive(value, currentValue) {
      if (
        Array.isArray(value) &&
        Array.isArray(currentValue) &&
        !this.multiple
      ) {
        return value.join(',') == currentValue.join(',')
      } else if (this.multiple) {
        return currentValue.includes(value)
      } else {
        return value === currentValue
      }
    },
    // 多下拉label侧级联选择
    handleLabelSelectItem(item) {
      this.hasSelected = true
      this.$emit('changeLabel', this.searchOpt, item.value, item.name)
    },
    // 单下拉
    handleSelectItem(item) {
      if (item.disabled) {
        return
      }
      this.hasSelected = true
      if (this.multiple) {
        // 先清除“全部”选项
        let find = this.selectList.find(i => {
          return i.isAll || (!i.isAll && i.value === '')
        })
        if (find) {
          this.currentValue.forEach((selectedItem, index) => {
            if (selectedItem === find.value) {
              this.currentValue.splice(index, 1)
            }
          })
        }
        // 选择全部
        if (item.isAll || (!item.isAll && item.value === '')) {
          this.$set(this, 'currentValue', [item.value])
          return
        }
        if (this.currentValue.includes(item.value)) {
          // 只有一个的时候 不能取消
          if (
            this.currentValue.length === 1 &&
            this.currentValue[0] === item.value
          ) {
            return
          }
          this.currentValue = this.currentValue.filter(i => i !== item.value)
        } else {
          this.currentValue.push(item.value)
        }
      } else {
        if (item.value === OTHER_TYPE.CUSTOM_DATE) {
          this.customDatePopupOpenFlag = true
          this.$emit('customDateChange', item.value)
          return
        }
        this.currentValue = item.value
        this.$emit('input', false)
      }
    },
  },
}
</script>
<style>
.van-popover--light .van-popover__arrow {
  color: transparent !important;
}
</style>
<style lang="scss" scoped>
.van-popover__wrapper {
  flex: 1;
}
.select-main {
  display: flex;
  align-items: center;
  .select-title {
    margin-right: 8px;
    flex: none;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    font-size: var(--set-font-size14);
    color: #919499;
  }
}
.select-panel-container {
  display: flex;
  gap: 17px;
  box-shadow: 0 10px 60px 20px rgba(32, 33, 36, 0.08);
  background: #ffffff;
  border-radius: 12px;
  padding: 0 16px;
  box-sizing: border-box;
  .select-panel {
    height: auto;
    box-sizing: border-box;
    &:not(:last-of-type) {
      border-right: 1px solid #f5f7fa;
    }
    .panel-item {
      min-width: 104px;
      width: 100%;
      padding: 16px 0;
      max-width: 280px;
      box-sizing: border-box;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      font-size: var(--set-font-size14);
      color: #202124;
      line-height: 20px;
      text-align: left;
      &.disabled {
        color: #c0c4cc;
      }
      &.active {
        color: #006cff;
      }
      &:not(:last-of-type) {
        border-bottom: 1px solid #f5f6f7;
      }
    }
  }
}
.select-button {
  height: 100%;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 13px;
  font-size: var(--set-font-size13);
  color: #202124;
  text-align: right;
  font-style: normal;
  background: #ffffff;
  border-radius: 6px;
  border: 1px solid transparent;
  justify-content: space-between;
  flex: 1;
  .label {
    color: var(--color-Text-text-primary3, #919499);
    /* 正文·13/13·Regular */
    font-family: 'PingFang SC';
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 153.846% */
    margin-right: 10px;
  }
  &.active {
    //border-color: #006cff;
    img {
      transform: rotate(180deg);
      transform-origin: center center;
    }
  }
  img {
    padding: 4px;
    width: 8px;
    height: 6px;
    transition: transform 0.3s;
    transform: rotate(0);
  }
  div {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
.time {
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 12px;
  font-size: var(--set-font-size12);
  color: #202124;
  line-height: 20px;
}
</style>
